import { USEABLE_FLAG } from '@/business/couponList';
import { i18n } from '@/i18n';
import { Route } from 'vue-router';
import couponIconDisabled from '../assets/images/new-version/coupon-disabled.png';
import couponIconActive from '../assets/images/new-version/coupon-icon.png';
import discountIconDisabled from '../assets/images/new-version/discount-disabled.png';
import discountIconActive from '../assets/images/new-version/discount-icon.png';
import weCouponActive from '../assets/images/new-version/wecoupon-icon.png';
import weCouponDisabled from '../assets/images/new-version/wecoupon-disabled.png';
import { isFromWecoupons, isShowWeCouponsBottomTab } from '@/business/we-coupons';


export const HeaderTabType = {
  couponlist: 'couponlist',
  stamplist: 'stamplist',
  displaycouponlist: 'displaycouponlist',
  voucherlist: 'voucherlist',
  weCouponList: 'wecouponList', //  抢券有SO
};

export const HeaderTabText = [
  {
    key: HeaderTabType.couponlist,
    text: i18n('優惠券'),
    children: [
      { key: HeaderTabType.couponlist, text: i18n('自動扣減券') },
      { key: HeaderTabType.displaycouponlist, text: i18n('手動啟用券') },
    ],
  },
  { key: HeaderTabType.stamplist, text: i18n('印花卡') },
  { key: HeaderTabType.voucherlist, text: i18n('消费券') },
];

export const BottomTabType = {
  home: 'home',
  homeNewest: 'homeNewest',
  couponlist: 'couponlist',
  weCoupons: 'weCoupons', //  抢券有SO
};

export const getBottomTabText = () =>  {
  const springBottomTabConfig = [
    { key: BottomTabType.home, text: i18n('優惠'), ...getBottomTabIcon(BottomTabType.home) },
    { key: BottomTabType.weCoupons, text: i18n('領券'), ...getBottomTabIcon(BottomTabType.weCoupons) },
    { key: BottomTabType.couponlist, text: i18n('我的禮遇'), ...getBottomTabIcon(BottomTabType.couponlist) },
  ];
  const res = springBottomTabConfig;

  return isFromWecoupons() ? res.filter(item => item.key !== BottomTabType.home) : res;
};

export const getBottomTabIcon = (tabType: string) => {
  switch (tabType) {
    case (BottomTabType.home):
      return  { iconSrc: discountIconActive, iconSrcDisabled: discountIconDisabled };
    case (BottomTabType.couponlist):
      return { iconSrc: couponIconActive, iconSrcDisabled: couponIconDisabled };
    case (BottomTabType.weCoupons): {
      const normalSrc = { iconSrc: weCouponActive, iconSrcDisabled: weCouponDisabled };
      return normalSrc;
    }
    default:
      return;
  }
};

/**
 * 判断顶部tab 路由是否为【卡券】类型，且qry type不为【已失效列表】
 * @param curRoute 当前路由
 * @returns boolean
 */
export const isHeaderTabPage = (curRoute: Route) => {
  if (curRoute?.name) {
    const curOriginRoute = curRoute.name;
    return Object.keys(HeaderTabType).includes(curOriginRoute) && curRoute.query.type !== USEABLE_FLAG.INVALID;
  }
  return false;
};
/**
 * 获取当前激活态的tab和subtab信息
 */
export const getActiveInfo = (curRoute: Route) => {
  if (!curRoute.name) return;
  const routeName = curRoute.name;
  const tabInfo = HeaderTabText.find((item) => {
    // tab名称符合
    const isValidTab = item.key === routeName;
    // tab的subtab的名称符合
    const isValidSubTab = item.children?.some(item => item.key === routeName);
    return isValidTab || isValidSubTab;
  });
  const subTabInfo = tabInfo?.children?.find(item => item.key === routeName);
  return {
    activeTab: tabInfo?.key,
    activeSubTab: subTabInfo?.key,
  };
};


/**
 * 判断底部tab
 * @param curRoute 当前路由
 * @returns boolean
 */
export const isBottomTabPage = (curRoute: Route) => {
  const curOriginRoute = curRoute.name;
  return isHeaderTabPage(curRoute)
    || (curOriginRoute === BottomTabType.home || curOriginRoute === BottomTabType.homeNewest)
    || isShowWeCouponsBottomTab(curRoute.path);
};
